<script lang="ts">
	import Layout from "@components/layout/Layout.svelte";
	import ArticlesSection from "@components/sections/ArticlesSection.svelte";
	import CaseStudiesSection from "@components/sections/CaseStudiesSection.svelte";
	import ClientsSection from "@components/sections/ClientsSection.svelte";
	import HeroSection from "@components/sections/HeroSection.svelte";
	import NewsletterSection from "@components/sections/NewsletterSection.svelte";
	import ProductsSection from "@components/sections/ProductsSection.svelte";
	import ServicesSection from "@components/sections/ServicesSection.svelte";
	import { getGlobalSettings } from "../contexts/getGlobalSettings.js";
	import type { HomepageProps } from "./HomepageProps.js";

	const { articles, caseStudies, homepageClients, products, mainCaseStudy }: HomepageProps = $props();
	const { FF_SHOW_PRODUCTS } = getGlobalSettings();
</script>

<Layout>
	<HeroSection />
	<ClientsSection clients={homepageClients} />
	<ServicesSection />
	<CaseStudiesSection
		heading="Komu a jak nl[[]] stroke[[jsme pomohli]]"
		caseStudies={caseStudies.slice(0, 12)}
		{mainCaseStudy}
	/>
	{#if FF_SHOW_PRODUCTS === "true"}
		<ProductsSection {products} />
	{/if}
	<NewsletterSection />
	<ArticlesSection {articles} />
</Layout>
